import { useEffect, useState } from "react";
import moment from "moment";
import { AdvanceSearchWrapper } from "../Shared/";
import { QICustomSelect, QIDateRangePicker, QIInput } from "../../../components";
import { useGetClientsQuery } from "../services";
import { useDropDownSearch } from "../../../hooks";

export const UsersAdvanceSearch = ({ onSearch, activeSearch }) => {
  const initialValues = {
    clients_id_in: "",
    filter_full_name_cont: "",
    email_cont: "",
    created_at_gteq: null,
    created_at_lteq: null,
  };

  const [formData, setFormData] = useState(initialValues);
  const [showCalender, setShowCalender] = useState(false);
  const [resetCount, setResetCount] = useState(0);

  useEffect(() => {
    if (activeSearch) {
      setFormData(activeSearch);
    }
  }, []);

  const dropmenuQueryParams = { per_page: 1000, order_by: "name" };

  // Get the clients list using Dropdown Search
  const {
    data: clients,
    setSearchKey: setClientSearch,
    isSuccess: clientsSuccess,
  } = useDropDownSearch({
    useData: useGetClientsQuery,
    simpleSearchKey: "name_or_email_cont",
    additionalParams: { ...dropmenuQueryParams },
    selectedIds: formData.clients_id_in,
  });

  const clearAdvanceSearch = () => {
    setResetCount((i) => i + 1);
    setFormData(initialValues);
    onSearch(null);
    setShowCalender(false);
  };

  const handleFormChange = (key, value) => {
    setFormData((prevState) => ({ ...prevState, [key]: value }));
  };

  const handleDateRange = (startTime, endTime) => {
    setFormData((prevState) => ({
      ...prevState,
      created_at_gteq: startTime,
      created_at_lteq: endTime,
    }));
    setResetCount((i) => i + 1);
  };

  return (
    <AdvanceSearchWrapper
      activeFilters={activeSearch}
      onClear={clearAdvanceSearch}
      onSearch={() => onSearch(formData)}
      showCalender={showCalender}
      setShowCalender={setShowCalender}
    >
      <QICustomSelect
        label="Client"
        value={formData.clients_id_in}
        onChange={(value) => {
          handleFormChange("clients_id_in", parseInt(value));
          setClientSearch("");
        }}
        onSearch={setClientSearch}
        labelClassName="client"
      >
        <li value="">Any</li>
        {clientsSuccess &&
          clients.data.map((client) => (
            <li key={client.id} value={client.id}>
              {client.name}
            </li>
          ))}
      </QICustomSelect>
      <QIInput
        label="Name"
        value={formData.filter_full_name_cont}
        onChange={(e) => handleFormChange("filter_full_name_cont", e.target.value)}
      />
      <QIInput
        label="Email"
        value={formData.email_cont}
        onChange={(e) => handleFormChange("email_cont", e.target.value)}
      />

      <QIDateRangePicker
        start={formData.created_at_gteq}
        end={formData.created_at_lteq}
        label={"Created b/w"}
        maxDate={moment()}
        onChange={handleDateRange}
        setShowCalender={setShowCalender}
        resetCount={resetCount}
      />
    </AdvanceSearchWrapper>
  );
};
